module.exports = __webpack_public_path__ + "img/dp_lp_pc_bg_3.c5a3b70a.jpg";